// src/pages/About.tsx

import React, {ReactElement, FC} from "react";
import {Box, Typography} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";

const Help: FC<any> = (): ReactElement => {

    let navigate = useNavigate();
    
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
        }}>
            <Grid container>
            <Grid item style={{height: '10px'}} xs={12}/>
            <Grid item xs={1} />
                <Grid item xs={11}>
                    <Typography color="black" variant="h5">
                        Help
                    </Typography>
                </Grid>
                <Grid item style={{height: '10px'}} xs={12}/>
                <Grid item xs={1} />
                <Grid item xs={10}>
                    <Typography color="black">
                        <p>You can use this application to explore the Milky Way in three dimensions out to about 5000 parsecs (16 thousand light-years) from the Sun.</p>
                        <p>You can see the location here superimposed on a model of the Milky Way from Stefan Payne-Wardnenaar.</p>
                        <img style={{width:"100%",maxWidth: "512px"}} src="https://gruze.org/3d/mw_overlay_cropped.jpg" />
                        <p>If you are using a mouse, the left button allows you to rotate, the right button allows you to pan, and the mouse wheel allows you to zoom in and out towards the current focus point (by default the Sun).</p>
                        <p>If you are using a touch device, one finger will rotate, two fingers will pan, and you can use a pinch gesture to zoom in and out.</p>
                        <p>You can use the search box to search for objexts with known distances. If the search is successful, the map will zoom into a sphere at that locations, and a dropdown widget will appear that will allow you to see information about the object.
                            While the widget is displayed the current focus point (for zooms) is set to the search object.</p>
                        <p>The bookmark icon in the top bar will copy a link to the current mesh configuration and position.</p>
                        <p>The home icon in the top bar will return you to the default position.</p>
                    </Typography>
                </Grid>
                <Grid item xs={1} />
            </Grid>
        </Box>
    );
};

export default Help;